export type RaffleStatus = "PRELAUNCH" | "PROMOTIONAL" | "LIVE" | "CLOSED" | "RESULTS";

export interface TicketPackage {
  entries: number;
  price: number;
}

export interface CampaignConfig {
  organizationName: string;
  campaignName: string;
  raffleName: string;
  eventDate: string;
  eventStartTime: string;
  eventEndTime: string;
  timezone: "America/New_York";
  venueName: string;
  venueAddress: string;
  permitNumber: string;
  ticketPackages: TicketPackage[];
  raffleStatus: RaffleStatus;
  salesOpeningTime: string;
  salesClosingTime: string;
  drawingTime: string;
  winnerPresenceRule: string;
  eligibility: string;
  contactEmail: string;
  contactPhone: string;
  mailingAddress: string;
  licenseDisplay: string;
  refundPolicy: string;
  sponsorBonusConditions: string;
  rulesEffectiveDate: string;
  claimDeadlineDays: number;
  useOfProceeds: string;
  sponsorName: string;
  sponsorPresenter: string;
  kickerPercentage: number;
  kickerMilestone: number;
  kickerPerMilestone: number;
  maximumKicker: number;
  communityImpactUrl: string;
  mainSllUrl: string;
  liveJotformUrl: string;
  aggregateTotalEndpoint: string;
  officialRulesPdf: string;
  winnerAnnouncement: string;
  winningTicketNumber: string;
  finalTicketSales: number | null;
  analyticsId: string;
}

export const EVENT_DEFAULTS = {
  organizationName: "Smithfield Little League",
  campaignName: "Light the Future",
  raffleName: "Light the Future 50/50 Raffle presented by Ben Vincent, CFP® | Edward Jones",
  eventDate: "2026-10-08",
  eventStartTime: "18:00",
  eventEndTime: "20:30",
  timezone: "America/New_York" as const,
  venueName: "Wright's Farm",
  venueAddress: "84 Inman Road, Burrillville, RI 02830",
  permitNumber: "No permit number issued",
  ticketPackages: [
    { entries: 1, price: 1 },
    { entries: 20, price: 10 },
    { entries: 50, price: 20 },
  ],
  salesOpeningTime: "2026-09-08T00:00:00-04:00",
  salesClosingTime: "2026-10-08T19:40:00-04:00",
  drawingTime: "2026-10-08T20:00:00-04:00",
  useOfProceeds:
    "Light the Future supports Smithfield Little League's next phase of field improvements, including our goal of adding lights to a second field.",
  sponsorName: "Edward Jones",
  sponsorPresenter: "Ben Vincent, CFP® | Edward Jones",
  kickerPercentage: 0,
  kickerMilestone: 1000,
  kickerPerMilestone: 100,
  maximumKicker: 1000,
  eligibility: "Participants must be at least eighteen (18) years old at the time of purchase. SLL may request proof of age and identity and may prohibit drawing administrators from participating.",
  winnerPresenceRule: "The winner is not required to be present at the drawing. SLL will attempt contact using the telephone number or email address associated with the winning entry.",
  contactEmail: "jay@smithfieldlittleleague.org",
  contactPhone: "401-954-2213",
  mailingAddress: "PO Box 17093, Smithfield, RI 02917",
  licenseDisplay: "The raffle license will be displayed at Wright's Farm in an area visible to the general public.",
  communityImpactUrl: "https://smithfield-little-league-impact.jmo8407.chatgpt.site/",
  mainSllUrl: "https://www.smithfieldlittleleague.org/",
  refundPolicy: "All purchases are final except when SLL cancels the raffle, cannot provide the purchased entries, or determines that a refund is necessary to correct an administrative or payment error.",
  sponsorBonusConditions: "The sponsor bonus is subject to the final written sponsorship commitment and applicable law. Edward Jones and Ben Vincent do not administer the raffle, select the winner, sell entries, or control the use of SLL's proceeds.",
  rulesEffectiveDate: "2026-09-08",
  claimDeadlineDays: 30,
};

export function isPlaceholder(value: string): boolean {
  return !value || value.startsWith("PLACEHOLDER_");
}
